const EXTERNAL_APPLICATION_STRING = "external-oauth";

export { EXTERNAL_APPLICATION_STRING };
